// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prescription-card[data-v-599d92ee] {\n  background-color: #ffecca;\n  border-color: #ffecca;\n  padding: 1.25rem;\n}\n.update-order[data-v-599d92ee],\n.followup-card[data-v-599d92ee],\n.prescription-details[data-v-599d92ee] {\n  background-color: rgba(26, 106, 114, 0.03);\n}", ""]);
// Exports
module.exports = exports;
